import { IDs } from '../../helpers/IDs';
import { isValid as isValidEigenstrom } from '../../main/functions/validData';

export function hasErneuerbareEnergien(data: any, standort_tid?: number): boolean {
    const eigenenergie: any = {};
    const entities: any = {
        1: IDs.ENT_ANLAGEN_EIGENSTROM_WINDKRAFT, 2: IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK, 3: IDs.ENT_ANLAGEN_EIGENSTROM_KWK,
        4: IDs.ENT_ANLAGEN_EIGENSTROM_SOLARTHERMIE, 5: IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN, 6: IDs.ENT_ANLAGEN_EIGENSTROM_BIOMASSE
    };

    (data[IDs.ENT_ANLAGEN_EIGENSTROM] || []).forEach((item: any) => {
        const standort: number = item.standort_tid_orig || null;
        const typ: number = item.anlagen_eigenstrom_typ_tid_orig || null;

        if (!standort || !typ) {
            return;
        }

        if (typeof eigenenergie[standort] === 'undefined') {
            eigenenergie[standort] = [];
        }
        eigenenergie[standort].push(typ);
    });

    if (!Object.keys(eigenenergie) || (standort_tid && (typeof eigenenergie[standort_tid] === 'undefined'))) {
        return false;
    }
    let hasData: boolean = false;

    Object.keys(eigenenergie).forEach((standort: string) => {
        if (hasData) {
            return;
        }

        Object.keys(entities).forEach((typ: string) => {
            if (hasData) {
                return;
            }

            if ((data[entities[typ]] || []).some((item: any) =>
                (
                    (standort_tid && (eigenenergie[standort_tid].indexOf(+typ) !== -1) && ((+item.standort_tid_orig || null) === +standort_tid))
                    || (!standort_tid && (eigenenergie[standort].indexOf(+typ) !== -1) && (+item.standort_tid_orig || null))
                )
                && isValidEigenstrom(item, entities[typ])
            )) {
                hasData = true;
            }
        });
    });

    return hasData;
}
